module.exports = __webpack_public_path__ + "img/part_6_4.ba966a19.webp";